import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Download from 'components/download.js';
import CommonFns from 'functions/common.ts';

function InnerInquiryDetail(props) {
  const Config = {
    purchase: {
      title: '询价需求单详情',
      apiPath: '/inquiry/Order/getDetail',
      publishApiPath: '/inquiry/inner/order/publish',
      enumMainKey: 'B02_Inquiry_Status',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Inner_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inquiry_Operate_Status',
          subKey: 'operateStatus',
          value: 'operateStatusName'
        },
        {
          mainKey: 'B02_Inquiry_Bill_Type',
          subKey: 'billType',
          value: 'billTypeName'
        }
      ],
      idField: 'inqXkNo',
      wfmCode: '1026'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    setWorkflow,
    self
  } = useDetail(props, config);
  self.idField = 'inqXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [takeNotesList, setTakeNotesList] = useState([]); //报价列表前端搜索的完整列表数据
  const [takeNotesList1, setTakeNotesList1] = useState([]); //报价列表前端搜索的当前列表数据
  const [quoteList, setQuoteList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [searchKey, setSearchKey] = useState('');
  // const [workflowData, setWorkflowData] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    EnumService.getValue('B02_Inquiry_Bill_Type', data.billType).then(value => {
      data.billTypeName = value;
    });
    EnumService.getValue('B02_Inquiry_Operate_Status', data.operateStatus).then(
      value => {
        data.operateStatusName = value;
      }
    );
    if (Array.isArray(data.vendorList) && data.vendorList.length > 0) {
      data.selectedCompanyCode = data.vendorList[0].innerVendorName;
    }
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      inqXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
  }

  //查看附件
  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = businessType === 6 ? obj.uniqueKey : detail.inqXkNo,
      xkNo = obj.inqXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  function handleOrder(type) {
    switch (type) {
      case 'publish':
        handlePublish(self.id);
        break;
      default:
    }
  }

  function handle(type) {
    handleOrder(type);
  }

  //发布询价
  function handlePublish() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label={detail.billTypeName} />
            {detail.status > 1 && (
              <Tab label={detail.billType === 1 ? '报价记录' : '投标记录'} />
            )}
          </Tabs>
        </Paper>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">标题</span>
                    <div className="field-value">{detail.billTitle}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户</span>
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    </li>
                  )}
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">询价企业</span>
                      <div className="field-value">
                        {detail.selectedCompanyCode}
                      </div>
                    </li>
                  )}
                  {/* 审批流状态 仅开启后才显示 */}
                  {workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={detail.inqXkNo}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div className="field-value">
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                  <li>
                    <span className="field-label">编号</span>
                    <div className="field-value">{detail.inqXkNo}</div>
                  </li>
                  <li>
                    <span className="field-label">状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Inner_Inquiry_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {Array.isArray(detail.productInfoMd5s) &&
                    detail.productInfoMd5s.length > 0 && (
                      <li>
                        <span className="field-label">附件</span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(68, detail)}
                          >
                            {detail.productInfoMd5s.length}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                </ul>
              </div>
            </div>
            {/* <div
              className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
              onClick={() => {
                handleMore(1);
              }}
            >
              {moreSign1 && '更多'}
              {!moreSign1 && '收起'}
              <i className="icon-down"></i>
            </div> */}
          </div>
          <div className="m-details-item">
            <div className="details-item-title">
              <label>询价/招标类型</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">类型</span>
                    <div className="field-value">
                      <span className="blue">{detail.billTypeName}</span>
                    </div>
                  </li>
                  {detail.billType === 2 && (
                    <li>
                      <span className="field-label">招标开始时间</span>
                      <div className="field-value">
                        {formatDate(detail.startDate, 'YYYY-MM-DD HH:mm:ss')}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">
                      {detail.billType === 1 ? '询价截止时间' : '招标结束时间'}
                    </span>
                    <div className="field-value">
                      {formatDate(detail.endDate, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">最终客户</span>
                      <div className="field-value">
                        <span>
                          {detail.usedByCustomerInnerCode
                            ? '(' + detail.usedByCustomerInnerCode + ')'
                            : ''}
                          {detail.usedByCustomerInnerName}
                        </span>
                        <div>
                          <FormControlLabel
                            disabled
                            control={
                              <Checkbox
                                checked={
                                  detail.showedVendorFlag === 1 ? true : false
                                }
                              />
                            }
                            label="是否显示给供应商"
                          />
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>{detail.billTypeName}物料</label>
            </div>
            <div className="details-item-content">
              {detail?.prodList?.length > 0 &&
                detail?.prodList.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(item.id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次 {item.lineNo}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">物料编码</span>
                        <div className="field-value">{item.productCode}</div>
                      </li>
                      <li>
                        <span className="field-label">物料名称</span>
                        <div className="field-value">{item.productName}</div>
                      </li>
                      <li>
                        <span className="field-label">物料规格</span>
                        <div className="field-value">{item.productScale}</div>
                      </li>
                      <li>
                        <span className="field-label">采购数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.purchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}{' '}
                          {item.purchaseUnitName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">采购单位</span>
                        <div className="field-value">{item.unitName}</div>
                      </li>
                      {item.descTag !== 1 && (
                        <li>
                          <span className="field-label">相关说明</span>
                          <div className="field-value">{item.description}</div>
                        </li>
                      )}
                      {item.descTag === 1 && (
                        <li>
                          <span className="field-label">相关说明</span>
                          <div className="field-value">
                            {item.descriptionList.map((val, i) => (
                              <div key={i} className="ml75">
                                {val.title}: {val.text}
                              </div>
                            ))}
                          </div>
                        </li>
                      )}
                      {Array.isArray(item.fileMd5s) &&
                        item.fileMd5s.length > 0 && (
                          <li>
                            <span className="field-label">图纸/文档</span>
                            <div className="field-value">
                              <span
                                className="attachment"
                                onClick={() => showFileList(6, item)}
                              >
                                {item.fileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                            </div>
                          </li>
                        )}
                    </ul>
                  </div>
                ))}
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>{detail.billTypeName}说明</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">付款方式</span>
                    <div className="field-value">{detail.payWayName}</div>
                  </li>
                  <li>
                    <span className="field-label">付款周期</span>
                    <div className="field-value">{detail.paymentCycleName}</div>
                  </li>
                  <li>
                    <span className="field-label">说明</span>
                    <div className="field-value">{detail.description}</div>
                  </li>
                  {Array.isArray(detail.fileMd5s) &&
                    detail.fileMd5s.length > 0 && (
                      <li>
                        <span className="field-label">
                          {detail.billTypeName}文件
                        </span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(5, detail)}
                          >
                            {detail.fileMd5s.length}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10070403') &&
            detail.status === 0 &&
            workflow.data &&
            workflow.data['inner_inq_publish_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('publish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

InnerInquiryDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InnerInquiryDetail);
